<template>
  <div id="app">
    <sy-table :data="tableDatas">
      <div slot="content-time" slot-scope="props">{{props.data.time}}123</div>
    </sy-table>

  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      input: '',
      msg: 'Welcome to Your Vue.js App',
       tableDatas:{
          head:[
            {field:"adress",name:"申请编号"},
            {field:"businessTravel",name:"申请项目"},
            {field:"time",name:"总价",sort:true},
            {field:"hours",name:"申请进度"},
            {field:"state",name:"物品名称",label:true},
            {field:"logContent",name:"数量",showTip:false}
          ],
          btns:[
            {name:"新增",icon:"el-icon-plus",disabled:false,loading:false},
            {name:"删除",icon:"el-icon-delete",disabled:false,loading:false}
          ],
          total:15,
          data: [{
              id:1,
              adress: '成都',
              businessTravel: '否',
              time: '1',
              hours:5,
              state:"审批中",
              logContent:"编写代码",
              test:1,
              timetip:[
                {
                  timeLength:1,
                  logSource:'其他1111111111111111111111111111111111111111111111111111111111111111',
                  logDetail:'点的'
                },
                {
                  timeLength:2,
                  logSource:'其他1',
                  logDetail:'点的2'
                }
              ]
            }, {
              id:2,
              adress: '成都',
              businessTravel: '否',
              time: '2',
              hours:5,
              state:"审批中",
              logContent:"编写代码",
              test:1
            }, {
              id:3,
              adress: '成都',
              businessTravel: '否',
              time: '3',
              hours:5,
              state:"审批中",
              logContent:"编写代码编写代码编写代码编写代码编写代码编写代码",
              test:1
            }, {
              id:4,
              adress: '成都',
              businessTravel: '否',
              time: '4',
              hours:5,
              state:"审批中",
              logContent:"编写代码",
              test:1
            }, {
              id:5,
              adress: '成都1',
              businessTravel: '否1',
              time: '5',
              hours:5,
              state:"审批中",
              logContent:"编写代码",
              test:1
            }]
      },
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue